import { render, staticRenderFns } from "./SkeletonHomeOrg.vue?vue&type=template&id=f2e9f2ae&scoped=true&"
var script = {}
import style0 from "./SkeletonHomeOrg.vue?vue&type=style&index=0&id=f2e9f2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9f2ae",
  null
  
)

export default component.exports